import React from "react";

import { Button, DatePicker, Dropdown, Input, Radio, RadioGroup, Form } from "rsuite";

import CustomDropdown from "../../../components/CustomDropdown";
import { useState } from "react";

export function SecondaryTraveler({ data, onChange }) {
  const [allergies, setAllergies] = useState("No");
  const [specialMeal, setSpecialMeal] = useState("");
  const [mobility, setMobility] = useState("No");
  return (
    <>
      <div className="card containerd mb-2 w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Secondary Traveler's Personal Information</h2>
        </div>
        <div className="card-body p-3 ">
          <Form.Group>
          <Input
            title={"Full Name as it appears on your passport"}
            label={"Full Name as it appears on your passport"}
            placeholder={"Full Name as it appears on your passport"}
            type={"text"}
            value={data?.secondary_full_name}
            onChange={(value) => onChange("secondary_full_name", value)}
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Passport Number"}
            label={"Passport Number"}
            placeholder={"Passport Number"}
            type={"text"}
            value={data?.secondary_passport_number}
            onChange={(value) => onChange("secondary_passport_number", value)}
          />
            </Form.Group>
          <Form.Group>
          {/*<label style={{ fontSize: 14 }}>Passport expiry date</label>*/}
          <DatePicker
            oneTap
            block
            format="yyyy/MM/dd"
            label={"Passport expiry date"}
            value={
              data?.secondary_passport_expiry_date
                ? data?.secondary_passport_expiry_date
                : undefined
            }
            onChange={(value) =>
              onChange("secondary_passport_expiry_date", value)
            }
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Nationality"}
            label={"Nationality"}
            placeholder={"Nationality"}
            type={"text"}
            value={data?.secondary_nationality}
            onChange={(value) => onChange("secondary_nationality", value)}
          />
            </Form.Group>
          <Form.Group>
          <DatePicker
            oneTap
            block
            format="yyyy/MM/dd"
            label={"Date of Birth"}
            value={
              data?.secondary_date_of_birth
                ? data?.secondary_date_of_birth
                : undefined
            }
            onChange={(value) => onChange("secondary_date_of_birth", value)}
          />
            </Form.Group>
        </div>
      </div>
      <div className="card containerd mb-2 w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Secondary Traveler's Address & Contact Information</h2>
        </div>
        <div className="card-body p-3 ">
          <Form.Group>
          <Input
            title={"Full Street Address"}
            label={"Full Street Address"}
            placeholder={"Full Street Address"}
            type={"text"}
            value={data?.secondary_full_street_address}
            onChange={(value) =>
              onChange("secondary_full_street_address", value)
            }
          />
            </Form.Group>
          <Form.Group>
          {/*<CustomDropdown*/}
          {/*  title={"City"}*/}
          {/*  col={"col-lg-12"}*/}
          {/*  showTitle*/}
          {/*  hide*/}
          {/*  onChange={(value) => onChange("secondary_city", value)}*/}
          {/*/>*/}
            <Input
                id="city"
                name="City"
                placeholder="City"
                value={data?.secondary_city}
                onChange={(e) => onChange("secondary_city", e)}
            />
            </Form.Group>

          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          <Form.Group>
          <Dropdown
            menuStyle={{ overflowY: "scroll", width: "100%" }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title={
              data?.secondary_country
                ? "Country : " + data?.secondary_country
                : "Country"
            }
          >
            {["Canada", "United States"].map((ele) => (
              <Dropdown.Item onClick={() => onChange("secondary_country", ele)}>
                {ele}
              </Dropdown.Item>
            ))}
          </Dropdown>
            </Form.Group>
            <Form.Group>
          <Input
            title={"Province/State"}
            label={"Province/State"}
            placeholder={"Province/State"}
            type={"text"}
            value={data?.secondary_province_or_state}
            onChange={(value) => onChange("secondary_province_or_state", value)}
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Postal Code/Zip Code"}
            label={"Postal Code/Zip Code"}
            placeholder={"Postal Code/Zip Code"}
            type={"text"}
            value={data?.secondary_postal_code_or_zip_code}
            onChange={(value) =>
              onChange("secondary_postal_code_or_zip_code", value)
            }
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Your Email Address"}
            label={"Your Email Address"}
            placeholder={"Your Email Address"}
            type={"text"}
            value={data?.secondary_email}
            onChange={(value) => onChange("secondary_email", value)}
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Your Phone Number"}
            label={"Your Phone Number"}
            placeholder={"Your Phone Number"}
            type={"text"}
            value={data?.secondary_phone_number}
            onChange={(value) => onChange("secondary_phone_number", value)}
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Emergency Contact Name"}
            label={"Emergency Contact Name"}
            placeholder={"Emergency Contact Name"}
            type={"text"}
            value={data?.secondary_emergency_contact_name}
            onChange={(value) =>
              onChange("secondary_emergency_contact_name", value)
            }
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Emergency Contact Phone Number"}
            label={"Emergency Contact Phone Number"}
            placeholder={"Emergency Contact Phone Number"}
            type={"text"}
            value={data?.secondary_emergency_contact_number}
            onChange={(value) =>
              onChange("secondary_emergency_contact_number", value)
            }
          />
            </Form.Group>
          <Form.Group>
          <Input
            title={"Emergency Contact Email Address"}
            label={"Emergency Contact Email Address"}
            placeholder={"Emergency Contact Email Address"}
            type={"text"}
            value={data?.secondary_emergency_contact_email}
            onChange={(value) =>
              onChange("secondary_emergency_contact_email", value)
            }
          />
          </Form.Group>
        </div>
      </div>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Secondary Traveler's Allergies & Food Preferences</h2>
        </div>
        <div className="card-body p-3 ">
          <label style={{ fontSize: 14, marginBottom: 10 }}>
            Do You have food allergies?
          </label>
          <RadioGroup
            name="sharingOption"
            onChange={(value) => {
              if (value == "No") {
                setAllergies("No");
                onChange("secondary_food_allergies", "No");
              } else {
                setAllergies("Yes");
                onChange("secondary_food_allergies", "");
              }
            }}
            // onChange={(value) => onChange("secondary_food_allergies", value)}
            defaultValue={
              data?.secondary_food_allergies
                ? data?.secondary_food_allergies
                : "No"
            } // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="No">No</Radio>
          </RadioGroup>

          {allergies == "Yes" && (
            <Input
              className="mb-2"
              as="textarea"
              rows={3}
              placeholder="Please list your food allergies"
              value={data?.secondary_food_allergies}
              onChange={(value) => onChange("secondary_food_allergies", value)}
            />
          )}
          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          <Dropdown
            menuStyle={{ overflowY: "scroll", width: "100%" }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title={
              "Do you have special meal requirements? " + ` ${specialMeal}`
            }
          >
            {["No", "Vegan", "Vegetarian", "Celiac", "Other"].map((ele) => (
              <Dropdown.Item
                // onClick={() =>
                //   onChange("secondary_special_meal_requirements", ele)
                // }
                onClick={() => {
                  if (ele == "Other") {
                    setSpecialMeal("Other");
                    onChange("secondary_special_meal_requirements", "");
                  } else {
                    setSpecialMeal(ele);
                    onChange("secondary_special_meal_requirements", ele);
                  }
                }}
              >
                {ele}
              </Dropdown.Item>
            ))}
          </Dropdown>

          {specialMeal == "Other" && (
            <Input
              as="textarea"
              className="mb-2"
              title={"Other special meal requirements"}
              label={"Other special meal requirements"}
              placeholder={"Other special meal requirements"}
              value={data?.secondary_special_meal_requirements}
              onChange={(value) =>
                onChange("secondary_special_meal_requirements", value)
              }
            />
          )}
          <div>
            <label style={{ fontSize: 14, marginBottom: 10 }}>
              Do you have any mobility issues?
            </label>
            <RadioGroup
              name="mobility"
              onChange={(value) => {
                if (value == "No") {
                  setMobility("No");
                  onChange("secondary_mobility_issues", "No");
                } else {
                  setMobility("Yes");
                  onChange("secondary_mobility_issues", "");
                }
              }}
              //   onChange={(value) => onChange("secondary_mobility_issues", value)}
              defaultValue={
                data?.secondary_mobility_issues
                  ? data?.secondary_mobility_issues
                  : "No"
              } // Set the default value to 'No' or 'Yes' based on your requirement
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </RadioGroup>
          </div>
          {mobility == "Yes" && (
            <Input
              className="mb-2"
              title={"please let us know what those are"}
              label={"please let us know what those are"}
              placeholder={"Please let us know what those are"}
              as="textarea"
              value={data?.secondary_mobility_issues}
              onChange={(value) => onChange("secondary_mobility_issues", value)}
            />
          )}
        </div>
      </div>
    </>
  );
}
